(() => {
  if (window.lmcdOfferCartDrawerReady) return;
  window.lmcdOfferCartDrawerReady = true;

  const funnels = new Map([
    ['46487649779898', '1508'],
    ['46584039375034', '1509'],
    ['46584039440570', '1510'],
    ['50529807925434', '1746'],
    ['50529864417466', '1747'],
    ['46584039309498', '1511'],
    ['46584039407802', '1512'],
    ['46742680207546', '1733'],
    ['46742691348666', '1734'],
    ['46742699999418', '1735'],
    ['46742704029882', '1736'],
  ]);
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'click_id'];
  const storageKey = 'lmcd_offer_cart_attribution';
  const checkoutSelector = '[data-lmcd-phoenix-checkout], [data-lmcd-offer-cart-checkout]';

  function closeElvasmaLocalCart(trigger) {
    const offer = trigger.closest('.lmcd-elvasma');
    if (!offer) return;
    offer.querySelectorAll('[data-elvasma-menu-drawer], [data-elvasma-cart-drawer]').forEach((drawer) => {
      drawer.classList.remove('elvTop_drawerOpen');
      drawer.setAttribute('aria-hidden', 'true');
    });
    offer.querySelector('[data-elvasma-drawer-backdrop]')?.classList.remove('elvTop_drawerBackdropOpen');
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-elvasma-cart-open]') : null;
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closeElvasmaLocalCart(trigger);
    const openCart = window.Shopify?.actions?.openCart;
    if (typeof openCart === 'function') openCart();
    else document.querySelector('theme-drawer#cart-drawer')?.open?.();
  }, true);

  // Offer header icons should show the same drawer as Add to Cart. Keep their
  // /cart href as a no-JavaScript fallback on non-offer pages.
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('.lmcd-house__cart, .lmcd-womans-heart__cart, .gb-header__actions a[aria-label="Cart"], .spiral-clone__cart')
      : null;
    if (!trigger?.closest('[data-lmcd-funnel-checkout]')) return;
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) return;
    const openCart = window.Shopify?.actions?.openCart;
    if (typeof openCart !== 'function' && typeof drawer.open !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (typeof openCart === 'function') openCart();
    else drawer.open();
  }, true);

  function readAttribution(query) {
    const values = {};
    for (const key of attributionKeys) {
      const value = query.get(key) || query.get(`lmcd_${key}`);
      if (value) values[key] = value;
    }
    const source = query.get('lmcd_funnel_source');
    if (source) values.lmcd_funnel_source = source;
    return values;
  }

  let attribution = {};
  try {
    attribution = readAttribution(new URLSearchParams(JSON.parse(sessionStorage.getItem(storageKey) || '{}')));
  } catch {
    // Storage can be disabled or contain an old value; checkout still works.
  }

  function captureAttribution() {
    attribution = { ...attribution, ...readAttribution(new URLSearchParams(window.location.search)) };
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(attribution));
    } catch {
      // The in-memory copy remains available when storage is unavailable.
    }
    return attribution;
  }

  function checkoutURL(link) {
    const { lmcdVariantId: variant, lmcdFunnelId: funnel, lmcdQuantity: quantity } = link.dataset;
    if (funnels.get(variant) !== funnel || !/^[1-9]\d*$/.test(quantity || '')) return null;
    if (!Number.isSafeInteger(Number(quantity))) return null;
    let url;
    try {
      url = new URL(link.href);
    } catch {
      return null;
    }
    if (url.origin !== 'https://secureorder.livingmadecleardeals.com' || url.pathname !== '/funnelish') return null;
    if (url.username || url.password || url.searchParams.get('store') !== 'u9nwjm-1w') return null;
    if (url.searchParams.get('funnelishId') !== funnel) return null;

    const values = captureAttribution();
    for (const key of attributionKeys) {
      if (!values[key]) continue;
      url.searchParams.set(key, values[key]);
      url.searchParams.set(`lmcd_${key}`, values[key]);
    }
    url.searchParams.set('lmcd_funnel_source', values.lmcd_funnel_source || 'direct_product');
    url.searchParams.set('lmcd_funnel_step', 'checkout');
    url.searchParams.set('lmcd_variant_id', variant);
    url.searchParams.set('lmcd_quantity', quantity);
    return url;
  }

  function hydrate() {
    const date = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date());
    document.querySelectorAll('[data-lmcd-sale-deadline]').forEach((node) => {
      if (node.textContent !== date) node.textContent = date;
    });
    document.querySelectorAll(checkoutSelector).forEach((link) => {
      const url = checkoutURL(link);
      if (url && link.href !== url.href) link.href = url.href;
    });
  }

  captureAttribution();
  // Updating the href during capture preserves the real click's full bubbling
  // path for existing checkout analytics. Native navigation follows dispatch.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest(checkoutSelector) : null;
    if (!link) return;
    if (link.dataset.lmcdCheckoutPending === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const url = checkoutURL(link);
    if (url) link.href = url.href;
  }, true);
  document.addEventListener('theme-drawer:open', hydrate);
  window.addEventListener('pageshow', hydrate);

  function start() {
    hydrate();
    const section = document.getElementById('shopify-section-cart-drawer-section');
    if (section) new MutationObserver(hydrate).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
